import { Component, OnInit } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../../environments/environment';
import {PostMessageService} from '../../../shared/services/post-message.service';
import {ProjectService} from '../../../shared/services/project.service';
import sanitizeForUrl from '../../../../utils/sanitizeForUrl';
import {Router} from '@angular/router';

@Component({
  selector: 'app-engine-smartbox',
  templateUrl: './engine-smartbox.component.html',
  styleUrls: ['./engine-smartbox.component.scss']
})
export class EngineSmartboxComponent implements OnInit {

  isB2B: Observable<any>;
  loggedUser: any;
  environment: any = environment.production;
  private widgetSubscription;

  constructor(private _postMessageService: PostMessageService,
              private _router: Router) {
  }

  ngOnInit(): void {
    const route = `smartbox`;
    this._router.navigate([route]);
  }
}
